import React, { useState } from "react";
import { GroupCartInfoPopupPropTypes } from "./types";
import { getSvgIcon } from "../../Helpers/get-assets";
import { CloseIcon } from "../Icons";
import Popup from "../Popup";
import Headline from "../Typography/Headline";
import Button from "../Button";
import i18next from "i18next";
import { MapPin, Clock, Check } from "react-feather";
import useGroupOrder from "../../global/useGroupOrder";
import { formatTimeslotEntryFromCart } from "../../Helpers/timeslot-utils";
import EmojiConfirmPopup from "../EmojiConfirmPopup";
import NotificationPopup from "../Popup/NotificationPopup";
import { fetchStoreData } from "../../Api/storeApi";

const GroupCartInfoPopup = ({ open, setOpen, handleCopy }) => {
    const { groupCartData, inviteUrl, abortGroupOrder, loading } =
        useGroupOrder();
    const [abortPopup, setAbortPopup] = useState(false);
    const isDelivery = groupCartData?.dispatch_type === "delivery";
    const ShareIcon = getSvgIcon("clipboard.svg");
    const [successfullyAborted, setSuccessfullyAborted] = useState(false);
    const DeliveryIcon = getSvgIcon(
        isDelivery ? "bicycle-new.svg" : "shop-new.svg"
    );
    const { storePickupAddress } = fetchStoreData(groupCartData?.store_id);

    const address = ((data) => {
        if (!data) {
            return "";
        }

        const { shipping_address, shipping_postcode, shipping_city } = data;

        if (!isDelivery) {
            return storePickupAddress;
        }

        return `${shipping_address}, ${shipping_postcode} ${shipping_city}`;
    })(groupCartData);

    const timeslot = ((data) => {
        if (!data) {
            return "";
        }

        return formatTimeslotEntryFromCart(data.slot_begin, data.slot_end);
    })(groupCartData);

    const onClose = () => setOpen(false);

    return (
        <>
            <Popup
                {...{
                    open: open,
                    isClosable: true,
                    handleClose: onClose,
                }}>
                <div className="group-cart-info">
                    <CloseIcon
                        onClick={onClose}
                        customClass="group-cart-info__close-btn"
                    />
                    <Headline size={6} className="group-cart-info__title">
                        {i18next.t("groupCartInfo.title")}
                    </Headline>
                    <section className="group-cart-info__details">
                        <div className="group-cart-info__detail">
                            <img src={DeliveryIcon} />
                            <p>
                                {i18next.t(
                                    `delivery.${
                                        groupCartData?.dispatch_type ||
                                        "delivery"
                                    }`
                                )}
                            </p>
                        </div>
                        <div className="group-cart-info__detail">
                            <MapPin />
                            <p>{address}</p>
                        </div>
                        <div className="group-cart-info__detail">
                            <Clock />
                            <p>{timeslot}</p>
                        </div>
                    </section>
                    <section className="create-grp-order__share-section">
                        <span>{i18next.t("groupCartInfo.shareLink")}</span>
                        <br />
                        <section className="create-grp-order__share-link">
                            <span>{inviteUrl}</span>
                            <button onClick={handleCopy}>
                                <img src={ShareIcon} alt="share-link" />
                            </button>
                        </section>
                    </section>
                    <br />
                    <Button
                        label={i18next.t("groupCartInfo.abort")}
                        onClick={() => {
                            setOpen(false);
                            setAbortPopup(true);
                        }}
                        size="SM"
                        variant={"danger"}
                    />
                </div>
            </Popup>
            <EmojiConfirmPopup
                open={abortPopup}
                setOpen={setAbortPopup}
                title={i18next.t("groupCartInfo.abortConfirm")}
                infoText={i18next.t("groupCartInfo.abortInfo")}
                ctaText={i18next.t("groupCartInfo.abort")}
                onConfirm={async () => {
                    await abortGroupOrder();
                    setSuccessfullyAborted(true);
                }}
                loading={loading}
            />
            <NotificationPopup
                open={successfullyAborted}
                onClose={() => setSuccessfullyAborted(false)}>
                <div className="create-grp-order__copy-success">
                    <div className="create-grp-order__copy-icon">
                        <Check />
                    </div>
                    <div className="create-grp-order__copy-info">
                        <span>
                            {i18next.t(
                                "groupCartInfo.successfullyAbortedTitile"
                            )}
                        </span>
                        <p>
                            {i18next.t(
                                "groupCartInfo.successfullyAbortedDescription"
                            )}
                        </p>
                    </div>
                </div>
            </NotificationPopup>
        </>
    );
};

GroupCartInfoPopup.propTypes = GroupCartInfoPopupPropTypes;
export default GroupCartInfoPopup;
